import _      from 'lodash'
import moment from 'moment'
import Model  from 'alto-orm/lib/orm/model'

class PersonalInfo extends Model
  constructor: (sex, birthDate, phone, phone2) ->
    super()

    @sex       = sex
    @birthDate = birthDate
    @phone     = phone
    @phone2    = phone2

  @attrNameMapping: { phone2: 'phone2' }

  @deserialize: (row) ->
    info = super(row)

    info.birthDate          = moment(row.birth_date)            if row.birth_date?
    info.birthDateUpdatedAt = moment(row.birth_date_updated_at) if row.birth_date_updated_at?

    info

  @serialize: (info) ->
    row = super(info)

    row.birth_date            = info.birthDate.format('YYYY-MM-DD')          if info.birthDate?
    row.birth_date_updated_at = info.birthDateUpdatedAt.format('YYYY-MM-DD') if info.birthDateUpdatedAt?

    row

class Address extends Model
  constructor: (country, city, areaCode, street, houseNumber) ->
    super()

    @country     = country
    @city        = city
    @areaCode    = areaCode
    @street      = street
    @houseNumber = houseNumber

class Company extends Model
  constructor: (name, ico, dic) ->
    super()

    @name = name
    @ico  = ico
    @dic  = dic

class Client extends Model
  constructor: (clientId, cardId, email, firstname, surname, personal, address,
                company, status, expirationDate, comment, news, dailyMenu, id) ->
    super()

    @clientId       = clientId
    @cardId         = cardId
    @email          = email
    @firstname      = firstname
    @surname        = surname
    @personal       = personal
    @address        = address
    @company        = company
    @status         = status
    @expirationDate = expirationDate
    @comment        = comment
    @news           = news
    @dailyMenu      = dailyMenu
    @id             = id

  @null: ->
    new @('Null client')

  @nominativeName: 'klient'
  @accusativeName: 'klienta'

  @onlyAttrs: ['id', 'clientId', 'cardId', 'chipId', 'email', 'firstname', 'surname', 'personal',
               'address', 'company', 'status', 'expirationDate', 'comment', 'news', 'dailyMenu']

  @deserialize: (row) ->
    client = super(row)

    personal = PersonalInfo.deserialize(row.personal or {})
    address  = Address.deserialize(row.address or {})
    company  = Company.deserialize(row.company or {})

    client.with(_.assign({ personal, address, company }))

  @serialize: (client) ->
    personal = PersonalInfo.serialize(client.personal) if client.personal
    address  = Address.serialize(client.address)       if client.address
    company  = Company.serialize(client.company)       if client.company

    _.assign({}, super(client), { personal, address, company })

  Object.defineProperty(@::, 'fullName', get: ->
    _.compact([@firstname, @surname]).join(' '))

Client.PersonalInfo = PersonalInfo
Client.Address      = Address
Client.Company      = Company

export default Client
